/* eslint-disable no-nested-ternary */
import { Expandable, Paragraph, Table } from '@tmov/design-system';
import { Edit, Eye, SpinnerMedium } from '@tmov/design-system/icons';
import { notification } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';

import LinkButton from '../../../../components/LinkButton';
import { LoadingContainer } from '../../../../components/LoadingContainer';
import apiNetCore from '../../../../services/apiNetCore';
import DemandaDetails from './DemandaDetails';
import { getColumns } from './getColumns';
import { DemandaContainer, DemandaHeader, TableContainer } from './styles';
import { getDemandaStatusWidget } from './utils/getDemandaStatusWidget';

function DemandaTable({ demanda }) {
  const [expanded, setExpanded] = useState(false);
  const [lotes, setLotes] = useState();
  const [loading, setLoading] = useState(false);
  const [sorter, setSorter] = useState({});

  const demandaHeader = useMemo(
    () => (
      <DemandaHeader>
        {getDemandaStatusWidget(demanda.status)}
        <LinkButton
          path={{ pathname: `/detalhesDemanda/${demanda.id}` }}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Eye style={{ fontSize: '24px' }} />
        </LinkButton>
        <LinkButton
          path={{
            pathname: `/lotes/demanda/${demanda.id}`,
            state: { step: 4 },
          }}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Edit style={{ fontSize: '24px' }} />
        </LinkButton>
      </DemandaHeader>
    ),
    [demanda.id, demanda.status]
  );

  const columns = getColumns(demanda.livreConcorrencia);

  useEffect(() => {
    const fetchLotes = async () => {
      setLoading(true);
      try {
        const { data } = await apiNetCore.get(
          `demanda/obter-lotes?idDemanda=${demanda.id}`
        );

        const lotesModificados = data.map(lote => ({
          ...lote,
          volumeCarregado: (lote.volume - lote.saldo).toFixed(3),
        }));

        setLotes(lotesModificados);
      } catch {
        notification.error({
          message: 'Ops, não foi possível obter os lotes',
          description:
            'Por favor, entre em contato com nosso suporte caso o problema persistir.',
        });
      }
      setLoading(false);
    };

    if (expanded) {
      fetchLotes();
    }
  }, [demanda.id, expanded]);

  return (
    <DemandaContainer>
      <Expandable
        expanded={expanded}
        headerContent={demandaHeader}
        changeExpanded={setExpanded}
      >
        <Expandable.Shown>
          <DemandaDetails demanda={demanda} />
        </Expandable.Shown>
        <Expandable.Hidden>
          {lotes ? (
            <TableContainer>
              <Table
                rows={lotes}
                columns={columns}
                sorting={{
                  sorter,
                  updateSorter: setSorter,
                }}
              />
            </TableContainer>
          ) : loading ? (
            <LoadingContainer height="10vh">
              <SpinnerMedium size="50px" />
            </LoadingContainer>
          ) : (
            <Paragraph style={{ marginTop: '20px' }}>
              Não foi possível encontrar lotes para esta demanda
            </Paragraph>
          )}
        </Expandable.Hidden>
      </Expandable>
    </DemandaContainer>
  );
}

DemandaTable.propTypes = {
  demanda: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.number,
    produto: PropTypes.string,
    cidadeCarregamento: PropTypes.string,
    cidadeDescarregamento: PropTypes.string,
    estadoCarregamento: PropTypes.string,
    estadoDescarregamento: PropTypes.string,
    saldo: PropTypes.number,
    volume: PropTypes.number,
    cadenciaDiariaTotal: PropTypes.number,
    livreConcorrencia: PropTypes.bool,
  }).isRequired,
};

export default DemandaTable;
